import React from 'react';
import sidebar from '@/css/module/sidebar.css';
import AddNewStep from '@/components/AddNewStep';
import { InteractiveDemoSuggestion } from '@/containers/StepsSidebar/InteractiveDemoSuggestion';
import { FROM } from '@/util/enums/EnumLayers';
import LayerHelper from '@/util/LayerHelper';
import { useLoadSteps_LEGACY } from '@/features/query-builder/hooks/LEGACY';
import AjaxSpinner from '@/components/AjaxSpinner';

export const AddNewStepControls = () => {
  const { all, selectedLayerId, isFetching } = useLoadSteps_LEGACY();

  if (isFetching) return <AjaxSpinner />;

  const layerHelper = new LayerHelper(all, selectedLayerId);

  const showInteractiveDemoSuggestion = !(
    layerHelper.inactiveLayers().length > 0 ||
    layerHelper.activeLayers().length > 1 ||
    all[0]?.layerType() !== FROM
  );

  return (
    <div className={`${sidebar.addLastStep} position-relative`}>
      <AddNewStep isLastStep />
      {showInteractiveDemoSuggestion && <InteractiveDemoSuggestion />}
    </div>
  );
};
